import { Link } from "@remix-run/react";
import { ThreeColGrid } from "..";

export const NotFoundPage = ({
  isPosterPage,
  locale,
}: {
  isPosterPage?: boolean;
  locale?: string;
}) => {
  return (
    <div className="p-4 md:p-12 min-h-[70vh]">
      <div className="md:text-center my-4">
        <h1 className="font-masonExtendedBold text-2xl md:text-3xl mb-2">
          {locale === "se"
            ? `Oj då, vi hittar inte ${isPosterPage ? "postern" : "kategorin"} du letar efter`
            : `Hmm, we don't seem to find the ${isPosterPage ? "poster" : "category"} you are looking for`}{" "}
        </h1>

        <h3 className="font-thin">
          {locale === "se" ? "Utforska vår" : "Explore our"}{" "}
          <Link className="underline" to={`/${locale}/posters`}>
            {locale === "se" ? "galleri" : "gallery"}
          </Link>{" "}
          {locale === "se"
            ? "eller prova en av dessa kategorier"
            : "or try one of these categories"}
        </h3>
      </div>

      <section>
        <ThreeColGrid hasImage locale={locale} />
      </section>
    </div>
  );
};

export default NotFoundPage;
